import * as React from "react"
import { useState, useCallback, useEffect } from "react"

import Container from "@components/elements/container"

import { internalRoutes } from "@data/routes"

import CloseIcon from "@images/close-icon.inline.svg"

import styles from "./banner.module.scss"

const HIDE_BANNER_STORAGE_NAME = "cookies-banner-hide"

const Banner = () => {
  const [isOpen, setIsOpen] = useState(true)

  useEffect(() => {
    if (localStorage.getItem(HIDE_BANNER_STORAGE_NAME)) {
      setIsOpen(false)
    }
  }, [])

  const hide = useCallback(() => {
    setIsOpen(false)

    localStorage.setItem(HIDE_BANNER_STORAGE_NAME, true)
  }, [])

  if (!isOpen) {
    return null
  }

  return (
    <div className={styles.banner}>
      <Container className={styles.container}>
        <div className={styles.text}>
          By using this website, you agree to{" "}
          <a href={internalRoutes.PRIVACY_POLICY}>our use of cookies</a>. We use
          cookies to provide you with a great experience and to help our website
          run effectively.
        </div>
        <button
          className={styles.buttonClose}
          onClick={hide}
          type="button"
          aria-label="Close information banner"
        >
          <CloseIcon className={styles.closeIcon} />
        </button>
      </Container>
    </div>
  )
}

export default Banner
